import { CheckboxV2, Flex, PopoverV2, useDisclosure } from '@withjoy/joykit';
import React from 'react';
import { CardFormat } from '../../../../ProductDetailsPage/constants';
import { PopoverBodyOverride, Trigger } from './FilterPill';
import { CHECKBOX_STYLE_OVERRIDES } from './ListCheckboxRow';
import { useFormatSearchParam } from '../useFormatSearchParam';
import { useTranslation } from '@shared/core';

// Derived from FilterPill
export const FormatFilterPill = () => {
  const { t } = useTranslation('stationery');
  const tFilterOptions = t('dashboard', 'designsGallery', 'filterOptions');

  const { isOpen, onClose, onOpen } = useDisclosure();

  const [format, setFormat] = useFormatSearchParam();

  const triggerLabel = (() => {
    if (format === 'all') return tFilterOptions['format']();
    if (format === CardFormat.premiumDigital) return tFilterOptions['format digital']();
    if (format === CardFormat.paper) return tFilterOptions['format paper']();
    return tFilterOptions['format']();
  })();

  return (
    <PopoverV2
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      placement="bottomStart"
      overrides={{
        Body: {
          props: {
            maxHeight: 320,
            maxWidth: 320,
            overflowY: 'scroll'
          },
          component: PopoverBodyOverride
        }
      }}
    >
      <PopoverV2.Trigger>
        <Trigger
          isOpen={isOpen}
          activeFiltersCount={0}
          label={triggerLabel}
          color={format ? 'white' : undefined}
          backgroundColor={format ? isOpen => (isOpen ? 'mono13' : 'mono14') : undefined}
        />
      </PopoverV2.Trigger>
      <PopoverV2.Content>
        <Flex flexDirection="column" paddingX={5} paddingY={4} rowGap={2}>
          <Flex height={8}>
            <CheckboxV2 overrides={CHECKBOX_STYLE_OVERRIDES} isChecked={format === CardFormat.paper || format === 'all'} onChange={() => setFormat(CardFormat.paper)}>
              {tFilterOptions['format paper']()}
            </CheckboxV2>
          </Flex>
          <Flex height={8}>
            <CheckboxV2
              overrides={CHECKBOX_STYLE_OVERRIDES}
              isChecked={format === CardFormat.premiumDigital || format === 'all'}
              onChange={() => setFormat(CardFormat.premiumDigital)}
            >
              {tFilterOptions['format digital']()}
            </CheckboxV2>
          </Flex>
        </Flex>
      </PopoverV2.Content>
    </PopoverV2>
  );
};
